var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"sort-arrow-container"},[(_vm.sortMethod !== _vm.activeMethod)?_c('icon',{attrs:{"name":"order"}}):[(_vm.sortDirection === 'desc')?_c('icon',{staticClass:"active",attrs:{"name":_vm.downName}}):_c('icon',{staticClass:"active",attrs:{"name":_vm.upName}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }